import { createFileRoute } from '@tanstack/react-router';
import JobPostTagsTemplate from '@/features/agent/job_post_tags/components/JobPostTagsTemplate';

export const Route = createFileRoute('/agent/job_post_tags')({
  component: JobPostTagsTemplate,
});
